import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getRequestStatus } from 'state/requests/RequestStatusSelectors';
import {
  getIRAContributionLimit,
  getIRAContributionPeriod
} from 'state/contributions/IRAContributionLimitSelectors';
import { getCustomerResidentialState } from 'state/customer/CustomerSelectors';
import {
  getContributionLimit,
  getContributionPeriod,
  getCustomerMailingAddress,
  getCustomerResidentialAddress
} from 'services/Rest';
import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';
import {
  hasReceivedMailingAddress,
  hasReceivedResidentialAddress
} from 'services/IRAContributionCard';
import otapi from '@opentelemetry/api';
import { compose } from 'redux';
import { withOtelContext } from '@trp-ta-nitro/otel-react';
import { residentialAddressEnabled } from 'services/FeatureFlags';

const IRADataProvider = (WrappedComponent) => {
  class IRAData extends Component {
    componentDidMount() {
      const { requestStatus, otelContext } = this.props;
      if(residentialAddressEnabled()) {
        if (!hasReceivedResidentialAddress(requestStatus)) {
          otapi.context.with(otelContext, () => {
            getCustomerResidentialAddress();
          });
        }
      } else {
        if (!hasReceivedMailingAddress(requestStatus)) {
          otapi.context.with(otelContext, () => {
            getCustomerMailingAddress();
          });
        }
      }
    }

    componentDidUpdate() {
      const { customerResidentialState, requestStatus, otelContext } =
        this.props;
      if (
        !requestStatus.contributionLimit &&
        requestStatus.contributionLimit !== REQUEST_STATES.received
      ) {
        otapi.context.with(otelContext, () => {
          getContributionLimit();
        });
      }

      if(residentialAddressEnabled()) {
        if (
          (hasReceivedResidentialAddress(requestStatus) ||
            requestStatus.residentialAddress === REQUEST_STATES.error) &&
          !requestStatus.contributionPeriod &&
          requestStatus.contributionPeriod !== REQUEST_STATES.received
        ) {
          otapi.context.with(otelContext, () => {
            getContributionPeriod(
              customerResidentialState ? customerResidentialState : 'MD'
            );
          });
        }
      } else {
        if (
          (hasReceivedMailingAddress(requestStatus) ||
            requestStatus.mailingAddress === REQUEST_STATES.error) &&
          !requestStatus.contributionPeriod &&
          requestStatus.contributionPeriod !== REQUEST_STATES.received
        ) {
          otapi.context.with(otelContext, () => {
            getContributionPeriod(
              customerResidentialState ? customerResidentialState : 'MD'
            );
          });
        }
      }
    }

    render() {
      const {
        iraContributionLimit,
        iraContributionPeriod,
        iraContributionYearToggle,
        requestStatus
      } = this.props;
      let data = {};
      let isLoading = true;
      let hasError = false;
      if (
        iraContributionLimit &&
        iraContributionPeriod &&
        iraContributionYearToggle
      ) {
        data = {
          iraContributionLimit: iraContributionLimit,
          iraContributionPeriod: iraContributionPeriod,
          iraContributionYearToggle: iraContributionYearToggle
        };
      }

      if (
        requestStatus.contributionPeriod === REQUEST_STATES.received &&
        requestStatus.contributionLimit === REQUEST_STATES.received
      ) {
        isLoading = false;
      }

      if (
        requestStatus.contributionPeriod === REQUEST_STATES.error ||
        requestStatus.contributionLimit === REQUEST_STATES.error
      ) {
        isLoading = false;
        hasError = true;
      }

      return (
        <WrappedComponent
          data={data}
          isLoading={isLoading}
          hasError={hasError}
        />
      );
    }
  }

  const mapStateToProps = (state) => ({
    iraContributionLimit: getIRAContributionLimit(state),
    iraContributionPeriod: getIRAContributionPeriod(state),
    iraContributionYearToggle: state.iraContributionYearToggle,
    requestStatus: getRequestStatus(state),
    customerResidentialState: getCustomerResidentialState(state)
  });
  return compose(withOtelContext, connect(mapStateToProps))(IRAData);
};

export default IRADataProvider;
